import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    // base: '/meidu/',
    // mode: 'history',
    routes: [{
            path: '/',
            meta: { keepAlive: true },
            redirect: '/login'
        },
        {
            path: '/index',
            meta: { keepAlive: true },
            component: resolve => require(['../components/common/Home.vue'], resolve),
            children: [{
                    path: '/',
                    name: '驾驶舱',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/index/welcome.vue'], resolve)
                }, {
                    path: '/dashBoard',
                    name: '电力优化',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/index/index.vue'], resolve)
                }, {
                    path: '/desc',
                    name: '详细信息',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/index/desc.vue'], resolve)
                }, {
                    path: '/changePassword',
                    name: '修改密码',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/change/changePassword'], resolve)
                }, {
                    path: '/role',
                    name: '角色管理',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/auth/role'], resolve)
                }, {
                    path: '/auth',
                    name: '用户管理',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/auth/auth'], resolve)
                }, {
                    path: '/meau',
                    name: '菜单管理',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/auth/meau'], resolve)
                }, {
                    path: '/operate',
                    name: '操作日志',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/auth/operate'], resolve)
                }, {
                    path: '/dict',
                    name: '字典管理',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/auth/dict'], resolve)
                }, {
                    path: '/dictValue',
                    name: '字典值管理',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/auth/dictValue'], resolve)
                }, {
                    path: '/electrovalence',
                    name: '电价设置',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/auth/electrovalence'], resolve)
                }, {
                    path: '/new',
                    name: '文章管理',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/news/new'], resolve)
                }, {
                    path: '/addNew',
                    name: '文章内容',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/news/addNew'], resolve)
                }, {
                    path: '/hrUpload',
                    name: 'i人事文件上传',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/hr/hrUpload'], resolve)
                }, {
                    path: '/enterprise',
                    name: '企业信息',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/doubleCarbon/enterprise'], resolve)
                }, {
                    path: '/equipment',
                    name: '设备监控',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/doubleCarbon/equipment'], resolve)
                }, {
                    path: '/enterpriseDesc',
                    name: '企业详情',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/doubleCarbon/enterpriseDesc'], resolve)
                }, {
                    path: '/calculate',
                    name: '碳核算计算记录',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/doubleCarbon/calculate'], resolve)
                },
                // {
                //     path: '/calculateAdd',
                //     name: '碳排放计算',
                //     meta: { keepAlive: true },
                //     component: resolve => require(['../components/page/doubleCarbon/calculateAdd'], resolve)
                // }, 
                {
                    path: '/calculateAdd',
                    name: '碳排放计算',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/doubleCarbon/calculateAddNew'], resolve)
                }, {
                    path: '/calculateAnalysis',
                    name: '碳分析',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/doubleCarbon/calculateAnalysis'], resolve)
                }, {
                    path: '/emptyPage',
                    name: '空页面',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/emptyPage.vue'], resolve)
                }, {
                    path: '/banner',
                    name: 'app轮播图管理',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/auth/banner.vue'], resolve)
                }, {
                    path: '/version',
                    name: '版本升级',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/auth/version.vue'], resolve)
                }, {
                    path: '/airCompressor',
                    name: '空压机系统节能',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/airCompressor/airCompressor.vue'], resolve)
                }, {
                    path: '/facility',
                    name: '无功补偿设备管理',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/electricEnergy/facility.vue'], resolve)
                }, {
                    path: '/lowTension',
                    name: '低压数据',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/electricEnergy/lowTension.vue'], resolve)
                }, {
                    path: '/caution',
                    name: '告警记录',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/electricEnergy/caution.vue'], resolve)
                }, {
                    path: '/history',
                    name: '历史信息',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/electricEnergy/history.vue'], resolve)
                }, {
                    path: '/energyAnalysisReport',
                    name: '用能分析报告',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/energyAnalysis/report.vue'], resolve)
                }, {
                    path: '/neeaList',
                    name: '户号信息',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/neea/list.vue'], resolve)
                }, {
                    path: '/electricityContract',
                    name: '售电合同',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/sellElectricity/electricityContract.vue'], resolve)
                }, {
                    path: '/brokerageContract',
                    name: '居间合同',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/sellElectricity/brokerageContract.vue'], resolve)
                }, {
                    path: '/brokerageDesc',
                    name: '居间方信息',
                    meta: { keepAlive: true },
                    component: resolve => require(['../components/page/sellElectricity/brokerageDesc.vue'], resolve)
                }
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../components/page/Login.vue'], resolve)
        },
        {
            path: '/screen',
            name: '数据化大屏',
            meta: { keepAlive: false },
            component: resolve => require(['../components/page/screen/screen'], resolve)
        },
        {
            path: '/doubleCarbon',
            name: '双碳数据化大屏',
            meta: { keepAlive: false },
            component: resolve => require(['../components/page/screen/doubleCarbon'], resolve)
        },
        {
            path: '/welcomeNew',
            name: '驾驶舱',
            meta: { keepAlive: false },
            component: resolve => require(['../components/page/index/welcomeNew'], resolve)
        }, {
            path: '*',
            redirect: '/emptyPage'
        }
    ],

});


// WEBPACK FOOTER //
// ./src/router/index.js